<template>
    <div data-interface-section="header-category-page">
        <Typography
            is="h1"
            size="s"
            type="header"
        >
            {{ props.category?.fullTitle }}
        </Typography>
        <ul
            v-if="category?.subCategories?.length"
            :class="$style.subCategories"
        >
            <li
                v-for="subCategory in category.subCategories"
                :key="subCategory.id"
            >
                <Button
                    interfaceTarget="category"
                    size="s"
                    :to="subCategory.href"
                    color="carbon-400"
                >
                    {{ subCategory.title }}
                </Button>
            </li>
        </ul>
    </div>
</template>
<script setup lang="ts">
import Button from '@/components_new/Button.vue'
import Typography from '@/components_new/Typography.vue'
import { CategoryInfo } from '@/types'

const props = defineProps<{
    category?: CategoryInfo
}>()
</script>
<style module>
.subCategories {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    overflow-x: auto;
    scrollbar-width: none;
    margin-top: 12px;
    gap: 4px;
    padding-bottom: 8px;
    margin-left: calc(var(--global-wide-scroller-padding-left) * -1);
    margin-right: calc(var(--global-wide-scroller-padding-right) * -1);
}
.subCategories::-webkit-scrollbar {
    display: none;
}

.subCategories li:first-child {
    margin-left: var(--global-wide-scroller-padding-left);
}

.subCategories li:last-child {
    margin-right: var(--global-wide-scroller-padding-right);
}
</style>
